import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, WarningCircle } from '@phosphor-icons/react';
import SubmitButton from './SubmitButton';

const ValidationBanner = ({ message }) => (
  <div
    className="flex items-start gap-3 bg-rose-50 border border-rose-200 text-rose-800 rounded-xl px-4 py-3 mb-5"
    data-testid="step-validation-error"
    role="alert"
  >
    <WarningCircle size={20} weight="fill" className="flex-shrink-0 mt-0.5 text-rose-600" />
    <div className="text-sm leading-relaxed font-medium">{message}</div>
  </div>
);

const NavigationControls = ({ step, totalSteps, loading, stepError, onPrevious, onNext, onSubmit }) => (
  <div className="mt-10 pt-6 border-t border-slate-100">
    {stepError && <ValidationBanner message={stepError} />}
    <div className="flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
      <Button
        onClick={onPrevious}
        variant="outline"
        disabled={step === 1}
        size="lg"
        className="border-slate-300 text-slate-700 hover:bg-slate-50"
        data-testid="previous-step-button"
      >
        <ArrowLeft size={20} className="mr-2" />
        Previous
      </Button>

      {step < totalSteps ? (
        <Button
          onClick={onNext}
          size="lg"
          data-testid="next-step-button"
          className="bg-gradient-to-r from-slate-900 to-teal-700 text-white hover:from-slate-800 hover:to-teal-600 shadow-md shadow-slate-900/10"
        >
          Continue
          <ArrowRight size={20} className="ml-2" />
        </Button>
      ) : (
        <SubmitButton loading={loading} onSubmit={onSubmit} />
      )}
    </div>
  </div>
);

export default NavigationControls;
